import { render } from "./OrdenesNPFacturacionView.vue?vue&type=template&id=1491ea20"
import script from "./OrdenesNPFacturacionView.vue?vue&type=script&lang=js"
export * from "./OrdenesNPFacturacionView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__